export const fmt = (n: number): string => n.toLocaleString('en-US');

export const fmtCompact = (n: number): string =>
  new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(n);

export const fmtPct = (x: number, digits = 0): string => `${(x * 100).toFixed(digits)}%`;

export const fmtDay = (iso: string): string => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const fmtDateTime = (iso: string): string => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
};

/** Humanize a RAG collectionId like "jordan_grade-10_sem-2_math" → "Math · G10 S2". */
export function prettySubject(collectionId: string): string {
  if (!collectionId || collectionId === '(no subject)') return 'No subject resolved';
  const parts = collectionId.split('_');
  const subject = parts[parts.length - 1] ?? collectionId;
  const grade = collectionId.match(/grade-(\d+)/)?.[1];
  const sem = collectionId.match(/sem-(\d+)/)?.[1];
  const tag = [grade ? `G${grade}` : '', sem ? `S${sem}` : ''].filter(Boolean).join(' ');
  const subjPretty = subject.charAt(0).toUpperCase() + subject.slice(1);
  return tag ? `${subjPretty} · ${tag}` : subjPretty;
}
